import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import { environment } from 'src/environments/environment';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { AuthserviceService } from 'src/app/services/authservice.service';
import { StorageService } from 'src/app/services/storage.service';

const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

@Component({
  selector: 'app-delete-account-request',
  templateUrl: './delete-account-request.component.html',
  styleUrl: './delete-account-request.component.css',
})
export class DeleteAccountRequestComponent implements OnInit {
  siteKey = environment.siteKey;
  protected aFormGroup!: FormGroup;
  faLock = faLock;
  deleteForm = new FormGroup({
    email: new FormControl(''),
    recaptcha: new FormControl(''),
  });
  recaptchaResponse: any;
  validate_email: any = true;
  submited: any = false;
  field_empty: boolean = false;
  delete_account_message: boolean = false;
  constructor(
    private router: Router,
    private _auth: AuthserviceService,
    private formBuilder: FormBuilder,
    private recaptchaV3Service: ReCaptchaV3Service,
    private storage: StorageService
  ) {}
  ngOnInit(): void {
    this.get_delete_account_messages();
    this.aFormGroup = this.formBuilder.group({
      recaptcha: ['', Validators.required],
    });
  }
  onSubmit(): void {
    this.submited = true;
    let email = this.deleteForm.get('email')!.value;
    if (this.deleteForm.valid) {
      if (!this.validateEmail(email)) {
        this.validate_email = false;
        this.submited = false;
        this.field_empty = false;
        this.delete_account_message = false;
        this.clearLocalStorageMessage();
        return;
      }
      if (!email) {
        this.field_empty = true;
        this.submited = false;
        this.delete_account_message = false;
        this.clearLocalStorageMessage();
        return;
      }
      this.recaptchaV3Service
        .execute('importantAction')
        .subscribe(async (token: string) => {
          if (token) {
            let user_details = { email: this.deleteForm.get('email')!.value };
            const response = await this._auth.delete_account_request(user_details, token);
            if (response?.success){
              this.router.navigate(['account/delete/request/success']);
              this.submited = false
              return
            }else if (response?.responseCode == 404){
              this.delete_account_message = true
              this.submited = false
            }else if (response?.responseCode!=404){
              this.router.navigate(['error']);
              this.submited = false
              return 
            }
          }
        });
    }
  }
  handleReset() {
    // Handle reset event
    console.log('reCAPTCHA reset');
    this.recaptchaResponse = null; // Reset the stored response on reset
  }

  handleExpire() {
    // Handle expire event
    console.log('reCAPTCHA expired');
  }

  handleLoad() {
    // Handle load event
    console.log('reCAPTCHA loaded');
  }

  handleSuccess(event: any) {
    // Handle success event
    console.log('reCAPTCHA success:', event);
    this.recaptchaResponse = event.token;
  }
  validateEmail(email: string | null): boolean {
    if (email) {
      return emailRegex.test(email);
    } else {
      return true;
    }
  }

  get_delete_account_messages() {
    const message = this.storage.getFromLocalStorage('message');
    if (message && message.toLowerCase() == 'record not found') {
      this.delete_account_message = true;
    }
  }

  clearLocalStorageMessage() {
    this.storage.removeFromLocalStorage('message');
  }
}
